import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    overlay: {
      position: "fixed",
      inset: 0,
      zIndex: 1500,
      backgroundColor: UIKIT_COLORS.OVERLAY_BG,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      position: "relative",
      maxWidth: "90vw",
      maxHeight: "90vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    image: {
      maxWidth: "90vw",
      maxHeight: "90vh",
      objectFit: "contain",
      borderRadius: 4,
      userSelect: "none",
    },
    closeBtn: {
      position: "fixed",
      top: 20,
      right: 24,
      width: 36,
      height: 36,
      borderRadius: "50%",
      backgroundColor: `${UIKIT_COLORS.OVERLAY_UI} !important`,
      "&:hover": { backgroundColor: `${UIKIT_COLORS.OVERLAY_UI_HOVER} !important` },
      "& .MuiSvgIcon-root": { fontSize: 16, color: UIKIT_COLORS.WHITE },
    },
    navBtn: {
      position: "fixed",
      top: "50%",
      transform: "translateY(-50%)",
      width: 44,
      height: 44,
      borderRadius: "50%",
      backgroundColor: `${UIKIT_COLORS.OVERLAY_UI} !important`,
      "&:hover": { backgroundColor: `${UIKIT_COLORS.OVERLAY_UI_HOVER} !important` },
      "&:disabled": { opacity: 0.2, cursor: "default" },
      "& .MuiSvgIcon-root": { fontSize: 22, color: UIKIT_COLORS.WHITE },
    },
    navBtnLeft: { left: 20 },
    navBtnRight: { right: 20 },
    count: {
      position: "fixed",
      bottom: 24,
      left: "50%",
      transform: "translateX(-50%)",
      color: "rgba(255,255,255,0.8)",
      fontSize: 13,
      fontWeight: 600,
    },
  })
);
